
import React, { useState, useEffect, useCallback } from 'react';
import { TextArea, Button, Modal } from 'carbon-components-react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import CheckMark from 'assets/image/CheckMark.svg';
import callGetApi from "../../../../requests/GetRequests";
import callPostApi from "../../../../requests/PostRequests"
import Download from 'assets/image/Download.svg';
import * as Constants from '../../../../requests/URLConstants';
import axios from "axios";
import moment from 'moment';
import * as IncidentDetailsUtil from '../../IncidentDetailsUtil.js';
import i18n from "../../../../i18n";
import * as urlConfig from "../../../../config/Constants";

var config = require('../../../../config/appConfig.json');
require("./_notes-tab.scss");


const NotesTab = props => {
  //console.log("notes sysid", props.sysId);
  //console.log("notes incidentid", props.incidentId);
  const [count, setCount] = React.useState(0);
  const [postcommentValue, setComment] = useState();
  const [updateIncidentStatusMessage, setUpdateIncidentStatusMessage] = useState();
  const [showIncidentUpdateModal, setShowIncidentUpdateModal] = useState(false);
  const [disablePostComment, setDisablePostComment] = useState(false);




  const NoDataWasFound = i18n.t('notes.NoDataWasFound');
  const Comment = i18n.t('notes.Comment');
  const WorkNotes = i18n.t('notes.WorkNotes');
  const DownloadingPleaseWait = i18n.t('notes.DownloadingPleaseWait');
  const PostComment = i18n.t('notes.PostComment');
  const Loading = i18n.t('notes.Loading');
  const YourTextGoesHere = i18n.t('notes.YourTextGoesHere');
  const Attachment = i18n.t('notes.Attachment');
  const WorkNotesElement = i18n.t('notes.WorkNotesElement');
  const InsufficientPrivileges = i18n.t('notes.InsufficientPrivileges');
  const UpdatedSuccessfully = i18n.t('notes.UpdatedSuccessfully');

  const [workNotesRequest, setWorkNotesRequest] = useState({
    loading: false,
    workNotes: null,
  });
  const { loading, workNotes } = workNotesRequest;

  const [attachmentRequest, setAttachmentRequest] = useState({
    loadingAttachment: false,
    attachment: null,
  });
  const { loadingAttachment, attachment } = attachmentRequest;

  const [combinedRequest, setCombinedRequest] = useState({
    loadingCombined: false,
    combinedNotes: null,
  });
  const { loadingCombined, combinedNotes } = combinedRequest;
  const [downloadAttachemnt, setDownloadAttachment] = useState(true);


  const handleCommentValue = useCallback(({ target }) => {
    setCount(target.value.length)
    setComment(target.value);
  }, []);


  const toggleIncidentUpdateModal = () => {
    setShowIncidentUpdateModal(!showIncidentUpdateModal);
  };

  const postComment = (e, param) => {
    e.preventDefault();

    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);

    let url = Constants.UPDATEINCIDENTURL + '/' + clientToSend + '/' + workspaceToSend + '/' + props.sysId;
    
    let payload;

    if (props.client.toLowerCase().includes("omv")) {

      payload = {
        "incident_id": props.incidentId,
        "work_notes": postcommentValue,
        "assignment_group": props.assignmentGroup,
      };
  
    } else {

      payload = {
        "incident_id": props.incidentId,
        "work_notes": postcommentValue,
      };
  
    }

    callPostApi(url, {
      'Content-Type': 'application/json'
    }, payload).then(response => {
      //console.log("update response 1", response);
      if (response === 403 || response === 401) {
        setUpdateIncidentStatusMessage(InsufficientPrivileges);
      } else {
        setUpdateIncidentStatusMessage(UpdatedSuccessfully);
      }
      setShowIncidentUpdateModal(true);
      setComment("");
      setCount(0);
      getIncidentActivity();


    }).catch(error => {
      setUpdateIncidentStatusMessage(InsufficientPrivileges);
      setShowIncidentUpdateModal(true);
      setComment("");
      setCount(0);
      //console.log("update response 2", error);
    });
  }

  const handleReset = () => {
    document.getElementById('post-comment').value = "";
  };

  async function getattachment() {
    setAttachmentRequest({ loadingAttachment: true });
    setAttachmentRequest({
      loadingAttachment: false,
      attachment: [],
    });

    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);

    let url = Constants.GETALLATTACHMENT + '/' + clientToSend + '/' + workspaceToSend + '/' + props.sysId;

    await callGetApi(url, {
      'Content-Type': 'application/json'
    }).then(res => {

      if (res) {
        setAttachmentRequest({
          loadingAttachment: false,
          attachment: res.result ? res.result : [],
        });
      }
    }).catch(error => {
      //console.log(error);
    });
  };

  async function getIncidentActivity() {

    setWorkNotesRequest({ loading: true });

    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);

    let notesUrl = Constants.GETINCIDENTACTIVITYURL + clientToSend + '/' + workspaceToSend + '/' + props.sysId;

    await callGetApi(notesUrl, { 'Content-Type': 'application/json' })
      .then(resp => {
        //console.log('response', resp);
        if (resp) {
          handleReset();
          setWorkNotesRequest({
            loading: false,
            workNotes: (resp.result ? resp.result : []),
          });
        } else {
          handleReset();
          setWorkNotesRequest({
            loading: false,
            workNotes: null,
          });

          setCombinedRequest({
            loadingCombined: false,
            combinedNotes: null,
          });
          setAttachmentRequest({
            loadingAttachment: false,
            attachment: null,
          });

        }
      }).catch((error) => {
        console.error('Error:', error);
      });
  };

  const downloadAttachment = async (attachmentSysId, filename) => {
    //console.log("downloadlink:", downloadlink);
    setDownloadAttachment(false);
    // let urlstrArr = downloadlink.split("/api/now/attachment/");
    // urlstrArr = urlstrArr[1].split("/file");
    // let downloadURL = config.serverUrl + "/api/incident/downloadAttachment/" + urlstrArr[0];
    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);


    // let body = {"attachmentUrl": downloadlink};
    let body = {
      "workspace": workspaceToSend,
      "client": clientToSend,
      "attachmentsysid": attachmentSysId
    };

    let downloadURL = config.serverUrl + "/api/incident/downloadAttachment";
    let user = JSON.parse(localStorage.getItem('user'));
    if (user !== null && user.access_token !== null) {
      // axios.get(downloadURL,
      //   {
      //     withCredentials: true,
      //     credentials: "include",
      //     responseType: 'arraybuffer',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Accept': '*/*'
      //     }
      //   })
      console.log("downloadbody",body);
      axios.post(downloadURL, body, {
        withCredentials: true,
        credentials: "include",
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*'
        }
      })
        .then((response) => {
          try {

            var blob = new Blob([response.data], { 'type': response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            setDownloadAttachment(true);

          } catch (e) {
            //console.log('error' + e);
          }
        })
      //.catch((error) => console.log(error) );

    }
  };

  const handleNotesData = () => {
    setCombinedRequest({ loadingCombined: true });

    if (workNotes && attachment) {

      var combinedData = workNotes.concat(attachment);

      combinedData.sort((a, b) => {
        return new Date(a.sys_created_on).getTime() -
          new Date(b.sys_created_on).getTime()
      }).reverse();

      setCombinedRequest({
        loadingCombined: false,
        combinedNotes: combinedData,
      });
    } else {
      if (!loading && !loadingAttachment) {
        setCombinedRequest({
          loadingCombined: false,
          combinedNotes: null,
        });

      }
    }

  };

  const getTime = (time) => {
    if (time) {
      let startM = moment(time);
      let startMStr = startM.locale("en").format("llll");
      return startMStr;
    }
    else {
      return "";
    }
  };

  useEffect(() => {
    
    setTimeout(() => {
      setComment("");
    });
    getIncidentActivity();
    getattachment();

  }, []);

  useEffect(() => {
    handleNotesData();
    if (count === 0) {
      setDisablePostComment(true);
    } else {
      setDisablePostComment(false);
    }

  }, [attachment, workNotes, count]);

  return (

    <div className="notes-container">
      {loadingCombined && Loading}
      {/* {!loadingCombined ?

      <div> */}
      <Modal
        passiveModal
        open={showIncidentUpdateModal}
        onRequestClose={toggleIncidentUpdateModal}
        onRequestSubmit={toggleIncidentUpdateModal}
      >
        <p>{updateIncidentStatusMessage}</p>
      </Modal>
      <div className="index">
        {combinedNotes && combinedNotes.length > 0 ? combinedNotes.map((key) => {
          return (
            <div key={key} className="margin-top-10px">
              <span>
                <AnchorLink className="anchor-tag" href={'#' + key.sys_created_on}>
                  <div className="margin-top-30px">
                    <div className="indexing">
                      <img src={CheckMark} alt="" />
                      <div className="index-first-value carbon-display-Regular-14">{key.sys_created_by}</div>
                    </div>
                    <div className="index-second-value notes-font-weight"> {getTime(key.sys_created_on)}</div>
                  </div>
                </AnchorLink>
              </span>
            </div>
          )
        }) :
          <div>
            {!loadingCombined && NoDataWasFound}

          </div>}

      </div>
      <div className="comments">

        <div className="text-count carbon-display-Regular-14">{count}/500</div>
              <TextArea className="carbon-display-Regular-14" id="post-comment" labelText={Comment} maxLength={500} rows={5} placeholder={YourTextGoesHere} onChange={handleCommentValue} disabled={props.disableIncidentUpdate || urlConfig.URL.includes(urlConfig.unilever) ? true : false} />
              <Button className="margin-top-10px margin-left-10px post-button" onClick={postComment} disabled={props.disableIncidentUpdate || disablePostComment || urlConfig.URL.includes(urlConfig.unilever) ? true : false}>{PostComment}</Button>
        <div className="margin-top-80px">
          <div className="margin-top-10px">
            {!downloadAttachemnt && DownloadingPleaseWait}
          </div>
          {combinedNotes && combinedNotes.length > 0 ? combinedNotes.map((key) => {
            return (
              <div className="card-notes margin-top-10px">
                <span id={key.sys_created_on}>
                  <div className="key-value-pair">
                    <div className="carbon-display-Semibold-14"> {key.sys_created_by}</div>
                    {key.element === 'attachment' ? <div className="notes-font-weight"> {WorkNotesElement} | {getTime(key.sys_created_on)}</div> : <div className="notes-font-weight"> {WorkNotesElement} | {getTime(key.sys_created_on)}</div>}
                  </div>
                </span>

                {key.element === 'attachment' ?
                  <div className="key-value margin-top-10px carbon-display-Regular-14" onClick={() => { downloadAttachment(key.sys_id, key.file_name) }}>
                    <a href="#" className="remove-underline-attachment ">
                      <div className="attachement-text">{key.file_name} </div>
                      <div>
                        <img className="image-size-download" src={Download} alt="" />
                      </div>
                    </a>
                  </div> :

                  <div className="key-value margin-top-10px carbon-display-Regular-14">
                    <div className="first-tag">{WorkNotesElement}</div>
                    <div className="middle-text display-linebreak">{key.value}</div>
                  </div>

                }

              </div>
            )
          }) : <div> {!loadingCombined && NoDataWasFound}</div>}
        </div>
      </div>
      {/* </div>
      :<div>Loading...</div>} */}
    </div>
  );


};

export default NotesTab;

